globalThis.PlayerAnimator = class PlayerAnimator {
  constructor(player) {
    this.player = player;
    this.current = "STANDING";
    this.step = 0;
    this.interval = setInterval(
      this.animate.bind(this),
      globalThis.ANIMATION_STEP,
    );
  }

  remove() {
    clearInterval(this.interval);
  }

  animate() {
    if (this.player.frozen) return;
    this.updateAnimName();
    const animation = globalThis.PLAYER_ANIMATIONS[this.current];
    if (!animation) return;
    this.step++;
    if (!animation.hanging) this.step %= animation.length;
    else this.step = Math.min(this.step, animation.length - 1);
    const frame = animation[this.step];
    this.player.setSpritePosition(frame.x, frame.y);
  }

  updateAnimName() {
    if (this.player.floating) this.current = "JUMPING";
    else if (this.player.grounded) {
      if (this.player.moving) {
        this.current = this.player.sprinting ? "RUNNING" : "WALKING";
      } else this.current = "STANDING";
    } else this.current = "JUMPING";
    this.player.setDebugBottom(this.player.grounded);
    this.player.setDebugTop(this.player.roofed);
    this.player.setDebugLeft(this.player.left_walled);
    this.player.setDebugRight(this.player.right_walled);
  }
};
